/**
 * TKP-178 md.48 — toplu ilgili kişi kaldırma / değiştirme (süreç ya da birim kapsamı). Saf: store/Vue yok.
 * Özet satırları backend'den (`/process-data/datasubject/summary`: ilgili kişi + düğüm sayısı); istek gövdesi buradan kurulur.
 */
export const MODES = ["remove", "replace"];

/** Özet satırları seçim bayrağıyla (kimlik dize). */
export const summaryRows = (summary = []) => (summary || []).map((r) => ({ id: String(r.datasubject && r.datasubject._id), name: r.datasubject && r.datasubject.name, nodes: Number(r.nodes) || 0, rows: Number(r.rows) || 0, items: r.items || [], checked: false }));

export const toggleRow = (rows, id, checked) => rows.map((r) => (r.id === String(id) ? { ...r, checked: !!checked } : r));
export const setAll = (rows, checked) => rows.map((r) => ({ ...r, checked: !!checked }));
export const selectedIds = (rows = []) => rows.filter((r) => r.checked).map((r) => r.id);

/** Kapsam: süreç verilirse süreç, yoksa birim (ikisi de yoksa null). */
export const scopeOf = ({ process, department } = {}) => (process && process._id ? { process: { _id: process._id } } : department && department._id ? { department: { _id: department._id } } : null);

/**
 * İstek gövdesi: kapsam + seçili ilgili kişiler; değiştirme kipinde `replaceWith` (organizasyon kaydı ya da kütüphane kalemi —
 * seçici karışık döndürebilir: `libraryItem` damgası olan organizasyon kaydıdır, yoksa kütüphane kalemi sayılır).
 * Geçersiz (kapsam yok, seçim yok, değiştirme kipinde hedef yok ya da hedef seçilenlerden biri) → null.
 */
export const removePayload = ({ process, department, rows = [], mode = "remove", replaceWith } = {}) => {
  const scope = scopeOf({ process, department });
  const ids = selectedIds(rows);
  if (!scope || !ids.length || !MODES.includes(mode)) return null;
  const payload = { ...scope, datasubjects: ids.map((_id) => ({ _id })) };
  if (mode === "replace") {
    if (!replaceWith || !replaceWith._id) return null;
    const target = replaceWith.organization ? { datasubject: { _id: replaceWith._id } } : { libraryItem: replaceWith };
    if (target.datasubject && ids.includes(String(replaceWith._id))) return null;
    payload.replaceWith = target;
  }
  return payload;
};

/**
 * TKP-242 q.4 — onay açıkken (onay yetkilisi değil) toplu uç kapalı: aynı iş adım adım (taslağa düşen tekil uçlar) arka planda.
 * Düğüm başına: değiştirme kipinde yeni ilgili kişi düğümde yoksa önce eklenir (organizasyon kaydı `create`, kütüphane kalemi
 * `addFromLibrary`), sonra seçilen ilgili kişilerin satırları silinir — toplu ucun sırasıyla aynı. Satır/düğüm kimlikleri özetin `items`ından.
 */
export const removeDraftPlan = ({ rows = [], mode = "remove", replaceWith } = {}) => {
  const selected = rows.filter((r) => r.checked);
  if (!selected.length || !MODES.includes(mode) || (mode === "replace" && !(replaceWith && replaceWith._id))) return [];
  const replaceId = mode === "replace" ? String(replaceWith._id) : null;
  if (replaceId && selected.some((r) => r.id === replaceId)) return [];
  const own = replaceId ? rows.find((r) => r.id === replaceId) : null; // yeni ilgili kişi kapsamda zaten varsa hangi düğümlerde
  const has = new Set(((own && own.items) || []).map((i) => String(i.node)));
  const byNode = new Map();
  for (const r of selected) for (const i of r.items || []) byNode.set(String(i.node), [...(byNode.get(String(i.node)) || []), String(i.row)]);
  const steps = [];
  for (const [node, rowIds] of byNode) {
    if (replaceId && !has.has(node)) {
      steps.push(replaceWith.organization
        ? { action: "create", store: "organizationProcessDataDatasubject/create", payload: { processData: { _id: node }, datasubject: { _id: replaceId } } }
        : { action: "create", store: "organizationProcessDataDatasubject/addFromLibrary", payload: { processData: { _id: node }, libraryItem: { ...replaceWith, fromLibrary: undefined } } });
    }
    for (const id of rowIds) steps.push({ action: "delete", store: "organizationProcessDataDatasubject/delete", id });
  }
  return steps;
};
